export default __webpack_public_path__ + "static/media/trilha.4c1d7cff.png";